import axios from 'axios';
import { httpApi } from './http';
import type { UsersListParams, UsersListResponse } from '../types/user';

const api = httpApi;

export class UserService {
  static async listUsers(params: UsersListParams = {}): Promise<UsersListResponse> {
    try {
      const response = await api.get<UsersListResponse>('/users', {
        params: {
          page: params.page ?? 1,
          limit: params.limit ?? 25,
          q: params.q ?? '',
          sortBy: params.sortBy ?? 'created',
          sortOrder: params.sortOrder ?? 'desc',
        },
      });

      if (!response.data) {
        throw new Error('No data received from server');
      }

      if (!response.data.success) {
        throw new Error(response.data.error || response.data.message || 'API request failed');
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        const apiError = (error.response?.data as any)?.error || (error.response?.data as any)?.message;

        if (apiError) {
          throw new Error(apiError);
        }

        if (status) {
          throw new Error(`Server error: ${status}`);
        }

        if (error.request) {
          throw new Error('Network error: Unable to connect to server');
        }
      }

      throw new Error('Failed to fetch users');
    }
  }
}
